import {
  Box,
  BoxProps,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useDividerColor } from "../../themes/colors";
import { menuNav } from "../../utils/etc";

interface Props extends BoxProps {
  onClose: () => void;
}

export const MenuNavDrawer = ({ onClose, ...rest }: Props) => {
  const navigate = useNavigate();
  const dividerColor = useDividerColor();
  const {
    isOpen: isLoginModalOpen,
    onOpen: onLoginModalOpen,
    onClose: onLoginModalClose,
  } = useDisclosure();

  const handleNavigation = (link?: string) => {
    link && navigate(link);
    window.scrollTo(0, 0);

    onClose();
  };

  return (
    <Box
      mt={6}
      pb={6}
      borderBottomWidth={"1px"}
      borderBottomColor={dividerColor}
      {...rest}
    >
      <Text textStyle={"b-sm-sb"} variant={"secondary"}>
        MENU
      </Text>

      <VStack gap={4} alignItems={"start"} mt={4}>
        {menuNav.map((navItem, index) =>
          navItem?.label === "Masuk" || navItem?.label === "Daftar" ? (
            <Text
              w={"full"}
              key={index}
              as={"button"}
              textAlign={"start"}
              textStyle={"b-reg-sb"}
              onClick={onLoginModalOpen}
            >
              {navItem.label}
            </Text>
          ) : (
            <HStack
              key={index}
              py={1}
              align={"center"}
              cursor={"pointer"}
              onClick={() => navItem?.href && handleNavigation(navItem?.href)}
            >
              <Text key={index} textStyle={"b-reg-sb"}>
                {navItem.label}
              </Text>
            </HStack>
          )
        )}
      </VStack>
    </Box>
  );
};
